import FundingWindowTriggerType from "@/models/Products/ProductSettings/DefaultSettings/FixedTerm/FundingWindowTriggerType";

export default (triggerType: FundingWindowTriggerType) => {
    let returnVal = "Undefined";
    switch (triggerType) {
        case FundingWindowTriggerType.FirstDeposit:
            returnVal = "First Deposit";
            break;
        case FundingWindowTriggerType.MinimumBalanceMet:
            returnVal = "Minimum Balance Met";
            break;
    }
    return returnVal;
}